import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/add-new-sales-invoices`;

export const addNewSalesInvoicesRoutesObj = {
  create: baseRoute,
} as const;

export type IAddNewSalesInvoicesRouteParams = IExtractRouteParamMap<
  typeof addNewSalesInvoicesRoutesObj
>;

export const addNewSalesInvoicesPath = createPaths<
  typeof addNewSalesInvoicesRoutesObj,
  IAddNewSalesInvoicesRouteParams
>(addNewSalesInvoicesRoutesObj);
